<template>
  <div class="body">
    <!-- Header -->
    <PageHeader/>

    <!-- Hero Section -->
    <section id="hero" class="d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div
              class="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1"
              data-aos="fade-up" data-aos-delay="200">
            <h1>
              {{ $t('main.home.title') }}
            </h1>
            <h2>
              {{ $t('main.home.subtitle1') }}
              <br/> <label style="font-size: 16px; padding-top: 12px;">
              {{ $t('main.home.subtitle2') }}
            </label>
            </h2>
            <div class="d-flex justify-content-center justify-content-lg-start">
            </div>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in"
               data-aos-delay="200">
            <img src="assets/img/hero-img.png" class="img-fluid animated"
                 alt="">
          </div>
        </div>
      </div>
    </section>
    <main id="main">
      <!-- Features Section -->
      <section id="features" class="why-us">
        <div class="container-fluid" data-aos="fade-up">
          <div class="row">
            <div class="col-lg-7 d-flex flex-column justify-content-center align-items-stretch order-1 order-lg-2">
              <div class="content">
                <h3><strong>{{ $t('main.feature.title') }}</strong></h3>
                <p>
                  {{ $t('main.home.subtitle1') }}
                </p>
                <p>
                  {{ $t('main.home.subtitle2') }}

                </p>
              </div>

              <div class="accordion-list">
                <ul>
                  <li><a data-bs-toggle="collapse" class="collapse" data-bs-target="#accordion-list-1"><span>01</span>
                    {{ $t('main.feature.list1.title') }}
                    <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i>
                  </a>
                    <div id="accordion-list-1" class="collapse show"
                         data-bs-parent=".accordion-list">
                      <p>
                        {{ $t('main.feature.list1.subtitle1') }}
                      </p>
                      <p>
                        {{ $t('main.feature.list1.subtitle2') }}
                      </p>
                    </div>
                  </li>
                  <li>
                    <a data-bs-toggle="collapse" data-bs-target="#accordion-list-2" class="collapsed"><span>02</span>
                      {{ $t('main.feature.list2.title') }}
                      <i class="bx bx-chevron-down icon-show"></i><i
                          class="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="accordion-list-2" class="collapse"
                         data-bs-parent=".accordion-list">
                      <p>
                        {{ $t('main.feature.list2.subtitle1') }}
                      </p>
                      <p>
                        {{ $t('main.feature.list2.subtitle2') }}
                      </p>
                    </div>
                  </li>
                  <li>
                    <a data-bs-toggle="collapse" data-bs-target="#accordion-list-3" class="collapsed"><span>03</span>
                      {{ $t('main.feature.list3.title') }}
                      <i class="bx bx-chevron-down icon-show"></i><i
                          class="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="accordion-list-3" class="collapse"
                         data-bs-parent=".accordion-list">
                      <p>
                        {{ $t('main.feature.list3.subtitle1') }}
                      </p>
                      <p>
                        {{ $t('main.feature.list3.subtitle2') }}
                      </p>
                      <p>
                        {{ $t('main.feature.list3.subtitle3') }}
                      </p>
                    </div>
                  </li>
                  <li>
                    <a data-bs-toggle="collapse" data-bs-target="#accordion-list-4" class="collapsed"><span>04</span>
                      {{ $t('main.feature.list4.title') }}
                      <i class="bx bx-chevron-down icon-show"></i><i
                          class="bx bx-chevron-up icon-close"></i>
                    </a>
                    <div id="accordion-list-4" class="collapse"
                         data-bs-parent=".accordion-list">
                      <p>
                        {{ $t('main.feature.list4.subtitle1') }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-5 align-items-stretch order-2order-lg-1 img"
                 :style="{ backgroundImage: `url('${bgImage}')` }"
                 data-aos="zoom-in" data-aos-delay="150">&nbsp;
            </div>
          </div>

        </div>
      </section>

      <!-- Services Section -->
      <section id="services" class="services section-bg">
        <div class="container" data-aos="fade-up">

          <div class="section-title">
            <h2>{{ $t('main.service.title') }}</h2>
            <p>{{ $t('main.service.subtitle') }}</p>
          </div>

          <div class="row">

            <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in" data-aos-delay="400">
              <div class="icon-box">
                <div class="icon">
                  <img src="@/assets/img/pics/service0.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <p>{{ $t('main.service.list1') }}</p>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 d-flex align-items-stretch"
                 data-aos="zoom-in" data-aos-delay="100">
              <div class="icon-box">
                <div class="icon">
                  <!-- <i class="bx bxl-dribbble"></i> -->
                  <img src="@/assets/img/pics/service1.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <!--
      <h4>
        <a href=""><s:message code="text.service1.title" /></a>
      </h4>
      -->
                <p>{{ $t('main.service.list2') }}</p>
              </div>
            </div>

            <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
                data-aos="zoom-in" data-aos-delay="200">
              <div class="icon-box">
                <div class="icon">
                  <!-- <i class="bx bx-file"></i> -->
                  <img src="@/assets/img/pics/service2.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <!--
      <h4>
        <a href=""><s:message code="text.service2.title" /></a>
      </h4>
      -->
                <p>{{ $t('main.service.list3') }}</p>
              </div>
            </div>

            <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in" data-aos-delay="300">
              <div class="icon-box">
                <div class="icon">
                  <!-- <i class="bx bx-tachometer"></i> -->
                  <img src="@/assets/img/pics/service3.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <!--
      <h4>
        <a href=""><s:message code="text.service3.title" /></a>
      </h4>
      -->
                <p>{{ $t('main.service.list4') }}
                </p>
              </div>
            </div>

          </div>

          <br/>

          <div class="row">

            <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in" data-aos-delay="400">
              <div class="icon-box">
                <div class="icon">
                  <!-- <i class="bx bx-layer"></i> -->
                  <img src="@/assets/img/pics/service4.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <!--
                <h4>
                    <a href="">Nemo Enim</a>
                </h4>
                -->
                <p>{{ $t('main.service.list5') }}
                </p>
              </div>
            </div>

            <div
                class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0"
                data-aos="zoom-in" data-aos-delay="400">
              <div class="icon-box">
                <div class="icon">
                  <img src="@/assets/img/pics/service6.svg" width="36px" alt=""
                       height="36px"/>
                </div>
                <p>{{ $t('main.service.list6') }}</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- About Section -->
      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h2>{{ $t('main.about.title') }}</h2>
          </div>
          <div class="row">
            <div class="col-lg order-2 order-lg-1 d-flex flex-column align-items-lg-center">
              <div class="icon-box mt-5 mt-lg-0" data-aos="fade-up" data-aos-delay="100">
                <p>
                  {{ $t('main.about.subtitle1') }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg order-2 order-lg-1 d-flex flex-column align-items-lg-center">
              <div class="icon-box mt-5" data-aos="fade-up" data-aos-delay="200">
                <p>
                  {{ $t('main.about.subtitle2') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Contact Section -->
      <section id="contact" class="contact section-bg">
        <div class="container" data-aos="fade-up">

          <div class="section-title">
            <h2>{{ $t('main.contact.title') }}</h2>
            <p></p>
          </div>

          <div class="row">

            <div class="col-lg-12 d-flex align-items-stretch">
              <div class="info">
                <div class="address">
                  <i class="bi bi-geo-alt"></i>
                  <h4>{{ $t('main.contact.address') }}:</h4>
                  <p>{{ $t('main.contact.address_value') }}</p>
                </div>

                <div class="email">
                  <i class="bi bi-envelope"></i>
                  <h4>{{ $t('main.contact.email') }}:</h4>
                  <p>info@sogate.net</p>
                </div>

                <div class="phone">
                  <i class="bi bi-phone"></i>
                  <h4>{{ $t('main.contact.phone') }}:</h4>
                  <p>+86 18054220178</p>
                </div>
              </div>
            </div>
            <!--            <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                          &lt;!&ndash;百度地图容器&ndash;&gt;
                          <div style="width:100%;height:318px;border:#ccc solid 1px;" id="dituContent">
                            &lt;!&ndash;            "vue-baidu-map-3x": "^1.0.40",
                                <baidu-map class="map" :center="{lng: 116.404, lat: 39.915}" :zoom="11"
                                                       style="width:600px;height:400px"/>&ndash;&gt;
                          </div>
                        </div>-->
          </div>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <PageFooter/>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import whyUs from '@/assets/img/why-us.png'
import {useHead} from "@vueuse/head";
import {useI18n} from 'vue-i18n'

export default {
  components: {
    PageHeader,
    PageFooter
  },
  setup() {
    const {t} = useI18n();
    useHead({
      title: 'SOGATE - 守云科技',
      meta: [
        {
          name: 'description',
          content: '为您的分布式员工队伍提供对私有数据的安全访问。用更安全、更易用且性能更优的零信任访问解决方案取代企业虚拟专用网络（VPN）。'
        },
        {name: 'keywords', content: 'Sogate, 安全接入服务网关, 零信任网络访问, ZTN, ZTNA, 安全访问, 网络安全, 零信任, VPN替代品, 企业安全解决方案, 私有数据访问, 分布式员工访问解决方案' }
      ],
      link: [
        {rel: 'icon', type: 'image/x-icon', href: '/logo.svg'}
      ]
    });
  },
  data() {
    return {
      bgImage: whyUs,
    };
  },
}
</script>

<style scoped>
a {
  text-decoration: none !important;
}
</style>